import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {NAVIGATION_HEIGHT} from '../constants';
import {useNavigationBarSection} from '../hooks/useGetHeaderBulkSection';
import {TopCategoryNavigationView} from './TopCategoryNavigationView';

export const TopCategoryNavigation: React.FC = props => (
  <DataFetcher
    request={useNavigationBarSection()}
    Loading={Skeleton}
    View={TopCategoryNavigationView}
    viewProps={props}
    Error={() => null}
  />
);

const Skeleton = () => {
  return <SkeletonBlock $height={`${NAVIGATION_HEIGHT}px`} />;
};
